module.exports = __webpack_public_path__ + "img/logo_black.cdd2ff53.png";